import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Card, Typography, Avatar } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import PageLayout from '../../../components/layout/PageLayout';
import { useUser } from '../../../context/UserContext';

const { Title, Text } = Typography;

const EditShow = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { user } = useUser();

  const handleBack = () => {
    navigate('/Video/Show');
  };

  // Header content with user info
  const headerContent = (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: '16px' }}>
        <Avatar 
          src={user?.avatar} 
          size={64} 
          style={{ marginRight: '16px' }}
        >
          {user?.name?.charAt(0)?.toUpperCase()}
        </Avatar>
        <div>
          <Title level={4} style={{ margin: 0, marginBottom: '4px' }}>
            {user?.name || 'Admin'}
          </Title>
          <Text type="secondary">Edit Video Show</Text>
        </div>
      </div>
    </div>
  );

  return (
    <PageLayout
      title="Edit Video Show"
      desc="Edit video show details"
      avatar={user?.avatar}
      headerContent={headerContent}
    >
      <Card>
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <Title level={3}>Edit Show - ID: {id}</Title>
          <Text type="secondary" style={{ fontSize: '16px', display: 'block', marginBottom: '20px' }}>
            This is a placeholder for the Edit Show functionality.
          </Text>
          <Button 
            type="primary" 
            icon={<ArrowLeftOutlined />}
            onClick={handleBack}
            size="large"
          >
            Go Back to Show List
          </Button>
        </div>
      </Card>
    </PageLayout>
  );
};

export default EditShow;
